<!--  -->
<template>
  <div class="staff-main">
    <div id="staff" class="scaleStyle"></div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  name: "staff",
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let staff = this.$echarts.init(document.getElementById("staff"));
      app.title = "";
      // 绘制图表
      staff.setOption({
        color: ["#67EEFF"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: ["<15个", "15-30", "30-35", "45-60", ">60"],
            axisTick: {
              alignWithLabel: true,
              lineStyle: {
                color: "#67EBFF"
              }
            },
            axisLine: {
              lineStyle: {
                color: "#67EEFF"
              }
            }
          }
        ],
        yAxis: [
          {
            splitLine: {
              lineStyle: {
                color: "#67EEFF",
                type: "dashed"
              },
              show: true
            },
            type: "value",
            axisTick: {
              alignWithLabel: true,
              lineStyle: {
                color: "#67EBFF"
              }
            },
            axisLine: {
              lineStyle: {
                color: "#67EEFF"
              }
            }
          }
        ],
        series: [
          {
            name: "直接访问",
            type: "bar",
            barWidth: "60%",
            data: [1300, 200, 900, 1600, 288]
          }
        ]
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.drawLine();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.scaleStyle {
  width: 100%;
  height: 100%;
  margin-left: -10px;
}
</style>
